import React from "react";
import { FormattedMessage } from "react-intl";
import { Button, Space, Row } from "@masterteam/mt-design-react";

import Modal from "../Modal";

import "./style.scss";

const ConfirmationModal = ({
  ButtonStatus,
  title,
  closeModal,
  handleSubmit,
  isOpen,
}) => {
  return (
    <Modal isOpen={isOpen}>
      <Space
        direction="vertical"
        size="large"
        className="confirmation-box-container"
      >
        <Space
          direction="vertical"
          size="large"
          justify="center"
          align="center"
        >
          <Space direction="vertical" align="center">
            <div className="title">{title}</div>
          </Space>
          <div className="modal-confirmation-body text-normal">
            <FormattedMessage id="common.confirmation-message" />
          </div>
        </Space>

        <Row justify="center" size="medium">
          <Button variant="dark" type="button" onClick={closeModal}>
            <FormattedMessage id="common.cancel" />
          </Button>
          <Button
            variant="primary"
            type="button"
            onClick={handleSubmit}
            loading={ButtonStatus}
          >
            <FormattedMessage id="common.send" />
          </Button>
        </Row>
      </Space>
    </Modal>
  );
};

export default ConfirmationModal;
